import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid",
  id: "comparison-tool"
}
const _hoisted_2 = { class: "col left-col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "divider v" }, null, -1)
const _hoisted_4 = { class: "col chart" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "divider h" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.organizations.isReady)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.organizations.isReady)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode($setup["Filters"], {
            showFilters: $setup.showFilters,
            selectedFilters: $setup.selectedFilters,
            showLocation: $setup.showLocation,
            "onUpdate:showFilters": _cache[0] || (_cache[0] = ($event: any) => ($setup.handleShowFilters())),
            "onUpdate:filtersChange": _cache[1] || (_cache[1] = ($event: any) => ($setup.handleFiltersChange($event))),
            "onUpdate:clearFilters": _cache[2] || (_cache[2] = ($event: any) => ($setup.handleClearFilters($event)))
          }, null, 8, ["showFilters", "selectedFilters", "showLocation"])
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["Chart"], {
            filteredOrgs: $setup.filteredOrganizations,
            selectedColumns: $setup.xAxisState
          }, null, 8, ["filteredOrgs", "selectedColumns"]),
          _hoisted_5,
          _createVNode($setup["XAxis"], {
            "onUpdate:selectedColumns": _cache[3] || (_cache[3] = ($event: any) => ($setup.handleColumnsSelection($event))),
            selectedColumns: $setup.xAxisState
          }, null, 8, ["selectedColumns"])
        ])
      ]))
    : _createCommentVNode("", true)
}